import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faNodeJs } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import { faDesktop } from "@fortawesome/free-solid-svg-icons";

const labelsFirst = [
    "Next.js", 
    "React",
    "Angular",
    "TypeScript",
    "JavaScript",
    "HTML5",
    "CSS3",
    "Redux",
    "Strapi",
    "MUI",
    "Bootstrap",
    "PeerJs",
    "ChartJs"
];

const labelsSecond = [
    "NodeJs",
    "ExpressJs",
    "MySql",
    "MongoDb",
    "Git",
    "AWS S3 & EC2",
    "GCP Storage",
    "Postman",
    "GraphQL", // Added GraphQL
    "Docker" // Moved Docker to backend skills
];

const labelsThird = [
    "ElectronJs" // Removed Docker from here
];

function Expertise() {
    return (
        <div className="container" id="expertise">
            <div className="skills-container">
                <h1>Expertise</h1>
                <div className="skills-grid">
                    <div className="skill">
                        <FontAwesomeIcon icon={faReact} size="3x" />
                        <h3>Frontend Development</h3>
                        <p>I have built a diverse array of web applications from scratch using modern technologies such as React and PeerJS. I have a strong proficiency in the SDLC process and frontend + backend development.</p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsFirst.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    <div className="skill">
                        <FontAwesomeIcon icon={faNodeJs} size="3x" />
                        <h3>Backend Development</h3>
                        <p>After the initial planning phase, I design and implement the backend architecture by planning database schemas and developing APIs. This ensures a strong foundation for the application.</p><div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsSecond.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    <div className="skill">
                        <FontAwesomeIcon icon={faDesktop} size="3x" />
                        <h3>Desktop Application</h3>
                        <p>I design and develop cross-platform desktop applications using Electron.js. This includes setting up the application architecture, creating a seamless integration between the frontend and backend.</p><div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsThird.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Expertise;
